import styled from "@emotion/styled";
import {
  spacing,
  fontWeight,
  fontSize,
  lineHeight,
  duration,
  surface,
  text,
} from "@atlas-int/tokens";
import { bodyStyle } from "@atlas-int/ui";

const borderColor = text.muted;

/* Glossary and FAQ components */

export const DetailsPageContainer = styled.div`
  width: 90%;
  margin-bottom: 100px;

  @keyframes details-show {
    from {
      max-height: 0px;
    }
    to {
      max-height: 2000px;
    }
  }

  details[open] > *:not(summary) {
    animation-name: details-show;
    animation-duration: ${duration.slow};
    animation-fill-mode: forwards;
  }

  details:not([open]) > *:not(summary) {
    max-height: 0vh;
  }
`;

export const Details = styled.details``;

export const DetailsToggleIcon = styled.span`
  position: absolute;
  right: 0px;
  padding-right: ${spacing[4]};
  font-weight: ${fontWeight.bold};
`;

export const DetailsIconMore = "+";
export const DetailsIconLess = "-";

export const DetailsSummary = styled.summary`
  font-size: ${fontSize["3xl"]};
  line-height: 1.14;
  color: ${text.primary};
  border-top: 1px solid ${borderColor};
  background-color: ${surface.subtle};
  padding: ${spacing[8]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  list-style: none;
  -webkit-appearance: none;

  &::-webkit-details-marker {
    display: none;
  }

  &:hover {
    background-color: ${surface.subtleHover};
    cursor: pointer;
  }
`;

export const DetailsContent = styled.div`
  overflow: hidden;
  box-sizing: border-box;
  border-top: 1px solid ${borderColor};

  a {
    color: ${text.content};

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    ${bodyStyle}
    padding: ${spacing[8]};
    margin-bottom: 0;
  }
`;

interface ToggleProps {
  isOpen: boolean;
}

export const ToggleIcon = ({ isOpen }: ToggleProps) => {
  if (isOpen) {
    return <DetailsToggleIcon>{DetailsIconLess}</DetailsToggleIcon>;
  } else {
    return <DetailsToggleIcon>{DetailsIconMore}</DetailsToggleIcon>;
  }
};
